"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupRoomsByTypeAndBoard = void 0;
const occupancyDescription_1 = require("../occupancyDescription");
const getBedConfig = (room) => {
    if (room.bed_configuration === "Any")
        return "No Bed Preference";
    if (!room.room.bed_options)
        return "No Bed Preference";
    if (room.room.bed_options.length === 0)
        return "No Bed Preference";
    if (room.room.bed_options.length === 1) {
        const bed_opts = [];
        if (room.room.bed_options) {
            room.room.bed_options.forEach((bedroom) => {
                const types = [];
                bedroom.config.forEach((bed) => {
                    if (bed.quantity > 0) {
                        types.push(`${bed.quantity} ${bed.bed_type}${bed.quantity > 1 ? "s" : ""}`);
                    }
                });
                bed_opts.push(types.join(" & "));
            });
        }
        return bed_opts.join(" or ");
    }
    return room.bed_configuration;
};
const groupRoomsByTypeAndBoard = (rooms) => {
    if (!rooms)
        return [];
    if (rooms.length === 0)
        return [];
    const grouped = rooms.reduce((acc, room) => {
        if (!room.room)
            return acc;
        if (Object.keys(room.room).length === 0)
            return acc;
        const key = `${room.room.name.en}-${room.board}-${room.occupancy}-${room.bed_configuration}`;
        const images = room.room.images ? JSON.parse(room.room.images) : [];
        const bed_config = getBedConfig(room);
        if (!acc[key]) {
            acc[key] = {
                id: "",
                images: [],
                name: `${room.room.name.en} (${(0, occupancyDescription_1.occupancyDescription)(room.occupancy)}/${room.board})`,
                bed_configuration: bed_config,
                room: room.room,
                board: room.board,
                quantity: 0,
                occupancy: 0,
                extra_beds: 0,
            };
        }
        acc[key].id = room.room.id;
        acc[key].images = images;
        acc[key].quantity += 1;
        acc[key].occupancy += room.occupancy;
        acc[key].extra_beds += room.extra_bed ? 1 : 0;
        return acc;
    }, {});
    return Object.values(grouped);
};
exports.groupRoomsByTypeAndBoard = groupRoomsByTypeAndBoard;
